<template>
   <div class="ui centered grid">
    <div class="sixteen wide column ">
        <form class="ui form" style="padding:30px;" id="noteform" method="post">
            <input v-if="!blank" type="hidden" name="uuid" v-bind:value="noteData.uuid">
            <div class="field">
                <label>Note:</label>
                <textarea name="note">{{noteData.note}}</textarea>
            </div>
            <br><br>
            <button v-if="blank" class="ui blue right floated button">Create Note</button>
            <button v-if="!blank" class="ui blue right floated button">Update Note</button>
            <button class="ui right floated button" v-on:click="cancel()" style="margin-right:5px">Cancel</button>
            <br><br>
            <div class="ui error message"></div>
        </form>
    </div>
</div>
</template>

<script>
    export default {
        props: ['blank', 'noteid'],
        data() {
            return {
                noteData: {
                    note: "",
                    related_items: ""
                }
            }
        },
        methods: {
            cancel: function() {
                //   this.$emit('formClose', 0);
                this.$router.push('notes');
            },
        },
        mounted() {
            if (!this.blank && this.noteid != "") {
                axios
                    .get('/api/note/' + this.noteid)
                    .then(response => {
                        this.noteData = response.data;
                        this.loading = false;
                    });
            }
            var myThis = this;
            var fields = {
                note: 'empty'
            }

            setTimeout(function() {
                $('#noteform').form({
                    on: 'blur',
                    fields: fields,
                    onSuccess: function(event, fields) {

                        event.preventDefault();
                        var formArray = $('form').serializeArray();
                        var postBody = {};
                        for (var i in formArray) {
                            postBody[formArray[i].name] = formArray[i].value;
                        }
                        if (myThis.blank) {
                            axios.post('/api/note', postBody)
                                .then(function(response) {
                                    console.log(response.status);
                                    myThis.$router.push({ path: '/notes' });
                                    //  myThis.$emit('formClose', response.status);
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    myThis.$router.push({ path: '/notes' });
                                    // myThis.$emit('formClose', error.response.status);
                                });
                        }
                        else {
                            axios.put('/api/note', postBody)
                                .then(function(response) {
                                    console.log(response);
                                    myThis.$router.push({ path: '/notes' });
                                    //   myThis.$emit('formClose', response.status);

                                })
                                .catch(function(error) {
                                    console.log(error);
                                    myThis.$router.push({ path: '/notes' });
                                    //  myThis.$emit('formClose', error.response.status);
                                });
                        }
                    }
                });
            }, 100);;

        },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TheNoteForm.vue